/**
 * Created by Christof Sander on 01.07.2016.
 */

// NOTE: due to a bug this component would not work properly if the action in effect doesn't provide a resourceRegisterContent for "nodeData"

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],

	config: {
		resourceRegisterKey: 'nodeData',
	},

	methods: {

		/**
		 * initialize component structure based on singe component resource instead of tree resource.
		 */
		dataDealer: function(){
			this.closest('templates_propertiesForms_componentContentForm', function(parent){
				if((parent.resourceData || {}).componentStructure){
					this.initComponentData((parent.resourceData || {}).componentStructure)
				}
			})
		},

		/**
		 * this function is used to sanitize resourceRegisterContent and overwrites the Component.prototype.sanitizeResourceRegisterContent method.
		 * therefor the parameters has to be equal to that function.
		 *
		 * in this case the model.fields will be taken from the resourceRegisterContent.
		 *
		 * @param data                          {} - Promise-Context of actions
		 * @param actionSourceName              string - name of the current actionSource
		 * @param resourceRegisterContent       mixed - resourceRegisterContent which has been placed for the actual component.
		 */
		sanitizeResourceRegisterContent: function(data, actionSourceName, resourceRegisterContent){
			this.initComponentData(resourceRegisterContent)
		},

		initComponentData: function(loadedComponent){
			if(((loadedComponent || {}).model || {}).fields){
				// overwrite fields (they may contain preloaded resources)
				this.model.fields = loadedComponent.model.fields;
				if(this.config.componentDataDependentFieldAssociation && loadedComponent.subType === 'form' || this.config.isFieldCodeSelector){
					this.config.deactivateFormComponentDataFields = true;
				}

				// merge actions (they may contain resource-preloading-actions needed to refresh their resources)
				var actionKey;
				for(actionKey in loadedComponent.actions || {}){
					if(this.actions[actionKey] === undefined){
						this.actions[actionKey] = loadedComponent.actions[actionKey];
					}
				}

				// sanitize form
				this.sanitizeForm();
			}
		},

		getResourceFilters: function(storage, resourceFilters, actionKey){
			let fieldIndex = ((this.actions || {})[actionKey || ''] || {}).fieldIndex
			if(fieldIndex === undefined) fieldIndex = -1;

			const field = (this.model.fields || [])[fieldIndex] || {}
			const dataType = (field.atom || {}).dataType

			const entityIDs = []
			if(dataType === 'media-image' || dataType === 'media-file'){
				resourceFilters = resourceFilters || {}
				for(const dataIndex in field.dataJSON || []){
					if(field.dataJSON[dataIndex].mediaID){
						entityIDs.push(field.dataJSON[dataIndex].mediaID)
					}
				}
				resourceFilters.listOfMediaIDs = entityIDs
			} else if(dataType === 'route-picker-full'){
				resourceFilters = resourceFilters || {}
				for(const dataIndex in field.dataJSON || []){
					if(field.dataJSON[dataIndex].routeID){
						entityIDs.push(field.dataJSON[dataIndex].routeID)
					}
				}
				resourceFilters.listOfRouteIDs = entityIDs
			}

			// TODO: POIA: tagPicker?!?

			return resourceFilters
		}
	}
};
